import { render, staticRenderFns } from "./menuAdministration.vue?vue&type=template&id=4c1dc67e&scoped=true"
import script from "./menuAdministration.vue?vue&type=script&lang=js"
export * from "./menuAdministration.vue?vue&type=script&lang=js"
import style0 from "./menuAdministration.vue?vue&type=style&index=0&id=4c1dc67e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1dc67e",
  null
  
)

export default component.exports